export default __webpack_public_path__ + "static/media/ongc-bg-2.4e7411e2.jpg";